import {useMobile} from "../../MobileContext";
import DesktopHeader from "../../components/DesktopHeader/DesktopHeader";
import styles from "../../styles/PageLayout.module.css";
import React from 'react';
import DashboardDesktop from "../dashboard/DashboardDesktop";

const FinancialManagerDashboard = () => {
    const isMobile = useMobile();

    return (
        <div className={styles.mainContainer}>
            {isMobile ? (
                <> </>
            ) : (
                <DesktopHeader
                    role={"financial-manager"}
                    showNotification={false}
                />
            )}
            <div className={styles.contentContainer}>
                <div className={styles.rightSectionContainer}>
                    {isMobile ? (
                        <> </>
                    ) : (
                        <DashboardDesktop role={"financial-manager"}/>
                    )}
                </div>
            </div>
        </div>
    )
}

export default FinancialManagerDashboard;